import { NoEditPlugin } from '../no-edit-plugin';
import { IExitDocumentPlugin } from './exit-document-plugin.interface';

export default class ExitDocumentPlugin extends NoEditPlugin implements IExitDocumentPlugin {
    public initPlugin(): void {
        // do nothing
    }

    public async exitCurrentDocument(): Promise<void> {
        try {
            const module = await import('@tencent/docs-application-service');
            const { DocsComponentFacade } = module;
            DocsComponentFacade.exitCurrentDocument();
        } catch (e) {
            window.log?.error?.('exit current document error');
        }
    }
}
